import { Device, DeviceConfig } from '@goodboydigital/astro';

const CustomDeviceSettings: DeviceConfig = {

    // === DESKTOP ============================================================

    ie: {
        match: 'browser:ie',
        resource: {
            version: 'default',
        },
        stage: {
            useHalfFPS: true,
            resolution: 0.75,
        },
    },

    // === ANDROID ============================================================

    android5: {
        match: 'os:android--os:version:5',
        resource: {
            version: 'default',
        },
        stage: {
            useHalfFPS: true,
            resolution: 0.75,
        },
    },

    android6: {
        match: 'os:android--os:version:6',
        resource: {
            version: 'default',
        },
        stage: {
            useHalfFPS: true,
            resolution: 0.75,
        },
    },

    android7: {
        match: 'os:android--os:version:7',
        resource: {
            version: 'default',
        },
        stage: {
            useHalfFPS: true,
            resolution: 0.75,
        },
    },

    android8: {
        match: 'os:android--os:version:8',
        resource: {
            version: 'default',
        },
        stage: {
            useHalfFPS: true,
            resolution: 0.75,
        },
    },

    // === IOS ============================================================

    iPhone5: {
        match: 'os:ios--device:iPhone5',
        resource: {
            version: 'default',
        },
        stage: {
            useHalfFPS: true,
            resolution: 0.5,
        },
    },

    iPhone6: {
        match: 'os:ios--device:iPhone6',
        resource: {
            version: 'default',
        },
        stage: {
            useHalfFPS: true,
            resolution: 0.75,
        },
    },

    iPhone7: {
        match: 'os:ios--device:iPhone7',
        resource: {
            version: 'default',
        },
        stage: {
            useHalfFPS: false,
            resolution: 0.75,
        },
    },

    iPhone8: {
        match: 'os:ios--device:iPhone8',
        resource: {
            version: 'default',
        },
        stage: {
            useHalfFPS: false,
            resolution: 0.75,
        },
    },
    
    // iPad: {
    //     match: 'os:ios--device:iPad',
    //     resource: {
    //         version: 'high',
    //     },
    //     stage: {
    //         useHalfFPS: false,
    //         resolution: 1,
    //     },
    // },
    
    ios: {
        match: 'os:ios--device:mobile',
        resource: {
            version: 'default',
        },
        stage: {
            useHalfFPS: false,
            resolution: 1,
        },
    },

    // === KINDLE ============================================================

    kindle: {
        match: 'device:kindle',
        resource: {
            version: 'default',
        },
        stage: {
            useHalfFPS: true,
            resolution: 0.5,
        },
    },

    // === MOBILE & DESKTOP DEFAULTS ==========================================

    mobile: {
        match: 'device:mobile',
        resource: {
            version: 'default',
        },
        stage: {
            useHalfFPS: false,
            resolution: 1,
        },
    },

    desktop: {
        match: 'os:desktop',
        resource: {
            version: 'high',
        },
        stage: {
            useHalfFPS: false,
            resolution: 1,
        },
    },
};

export {
    CustomDeviceSettings,
};
